export default "/_next/static/559064cae23053a2dad6de25458ba490.png";